import { render } from "./motion-results-page.vue?vue&type=template&id=2af9f96e"
import script from "./motion-results-page.vue?vue&type=script&lang=js"
export * from "./motion-results-page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__